module.exports = __webpack_public_path__ + "static/media/ExampleBill.9a39d079.csv";


//////////////////
// WEBPACK FOOTER
// ./src/statics/ExampleBill.csv
// module id = 2435
// module chunks = 0